/* Compact feature strip: native touch scrolling, keyboard navigation and desktop dragging. */
if (!customElements.get('lmb-sofa-features')) {
  customElements.define('lmb-sofa-features', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.view = this.querySelector('.lmb-sofa-features');
      if (!this.view) return;
      this.items = [...this.view.children];
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.view.addEventListener('keydown', event => {
        const key = event.key;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(key)) return;
        event.preventDefault();
        if (key === 'Home') this.go(0);
        else if (key === 'End') this.go(this.view.scrollWidth);
        else this.move(key === 'ArrowRight' ? 1 : -1);
      }, opts);
      this.view.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = { id: event.pointerId, x: event.clientX, left: this.view.scrollLeft, active: false };
      }, opts);
      this.view.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (!this.drag.active && Math.abs(delta) < 5) return;
        if (!this.drag.active) {
          this.drag.active = true;
          this.view.dataset.dragging = '';
          this.view.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.view.scrollLeft = this.drag.left - delta;
      }, opts);
      const release = event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        if (this.view.hasPointerCapture(event.pointerId)) this.view.releasePointerCapture(event.pointerId);
        this.drag = null;
        delete this.view.dataset.dragging;
      };
      this.view.addEventListener('pointerleave', () => { if (this.drag && !this.drag.active) this.drag = null; }, opts);
      this.view.addEventListener('pointerup', release, opts);
      this.view.addEventListener('pointercancel', release, opts);
      this.view.addEventListener('lostpointercapture', release, opts);
      this.dataset.ready = '';
    }
    disconnectedCallback() {
      this.events?.abort(); this.events = null;
      clearTimeout(this.destinationTimer);
    }
    positions() {
      const start = this.items[0]?.offsetLeft || 0;
      const max = Math.max(0, this.view.scrollWidth - this.view.clientWidth);
      return [...new Set(this.items.map(item => Math.min(max, item.offsetLeft - start)))];
    }
    move(direction) {
      const stops = this.positions();
      const left = this.destination ?? this.view.scrollLeft;
      const target = direction > 0 ? stops.find(x => x > left + 2) : [...stops].reverse().find(x => x < left - 2);
      this.go(target ?? (direction > 0 ? this.view.scrollWidth : 0));
    }
    go(left) {
      const max = Math.max(0, this.view.scrollWidth - this.view.clientWidth);
      this.destination = Math.max(0, Math.min(max, left));
      this.view.scrollTo({ left: this.destination, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      clearTimeout(this.destinationTimer);
      this.destinationTimer = setTimeout(() => { this.destination = null; }, 500);
    }
  });
}
